export const ROLE_IDS = {
  TELE_SALES: 8,
};
